// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"daec203f","181":"400cfe9e","190":"b0995eb6","225":"f2664fe1","268":"600a4627","296":"e1a82343","415":"4e7fb3d2","491":"ec1650b3","552":"9bbca011","830":"31bbd75d","953":"bb7539f5"}[chunkId] + ".chunk.js";
};